// 🔧 SubscribeForm.js
// ✅ Purpose: Reusable email capture form for global mailing list
// ✅ Features:
// - Saves email to /subscribers/{docId}
// - Shows success/error message
// - Can be reused on any public or admin page

import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { trackEvent } from "../utils/analytics";
import { GA_EVENTS } from "../services/analytics/ga_events";
import { logger } from '../utils/logger';

const SubscribeForm = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setStatus({ type: "danger", message: "Please enter your email." });
      return;
    }

    setSubmitting(true);
    setStatus(null);

    try {
      await addDoc(collection(db, "subscribers"), {
        email: email.trim().toLowerCase(),
        createdAt: serverTimestamp(),
      });
      setStatus({ type: "success", message: "✅ Subscribed! We'll be in touch." });

      trackEvent({
        action: GA_EVENTS.MAILING_LIST_SIGNUP,
        parameters: {
          source: "subscribe_form",
          source_page: window.location.pathname,
        },
      });

      setEmail("");
    } catch (err) {
      logger.error("❌ Subscription failed:", {
        value: err
      });
      setStatus({ type: "danger", message: "❌ Failed to subscribe. Try again later." });
    }

    setSubmitting(false);
    setTimeout(() => setStatus(null), 20000);
  };

  return (
    <div className="mt-3">
      {!showForm ? (
        <button
          className="btn btn-dark"
          onClick={() => {
            trackEvent({
              action: GA_EVENTS.MAILING_LIST_OPENED,
              parameters: {
                source: "subscribe_form",
                source_page: window.location.pathname,
              },
            });

            setShowForm(true);
          }}
        >
          📬 Join Mailing List
        </button>
      ) : (
        <form onSubmit={handleSubmit}>
          {status && <div className={`alert alert-${status.type}`}>{status.message}</div>}

          <div className="input-group">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="form-control"
              placeholder="Your email address"
              required
            />
            <button className="btn btn-dark" type="submit" disabled={submitting}>
              {submitting ? "Joining..." : "Join"}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default SubscribeForm;
